import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0;

  > header {
    display: flex;
    align-items: row;
    justify-content: space-between;
    align-items: center;

    padding: 1rem 1.5rem;
    background: ${props => props.theme.cards.primary};
    border: 1px solid ${props => props.theme.cards.border};
    //box-shadow: ${props => props.theme.shadows.primary};
    border-bottom: none !important;
    border-radius: ${props => props.theme.radius.primary} ${props => props.theme.radius.primary} 0 0;
    width: 100%;

    > aside {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      gap: 0.25rem;

      > h5 {
        font-size: 1rem;
        color: ${props => props.theme.colors.white};
      }

      > h6 {
        color: ${props => props.theme.colors.muted};
        font-size: 12px;
        font-weight: 400;
      }
    }


    > div {
      position: relative;
      color: ${props => props.theme.colors.gray};
      background: transparent;
      border: 1px solid ${props => props.theme.cards.border};
      border-radius: ${props => props.theme.radius.primary};
      padding: 0 0.5rem;
      
      
      > select {
        padding: 0.5rem 0.75rem 0.5rem 0.7rem;
        background: transparent !important;
        color: ${props => props.theme.colors.white};
        width: 110px;
        height: 42px;
        border: none;
        text-transform: capitalize;

        -webkit-appearance: none;
        -moz-appearance: none;
        text-indent: 1px;
        text-overflow: '';

        > option {
          color: ${props => props.theme.colors.white};
          background: ${props => props.theme.modal.background};
          text-transform: capitalize;
        }
      }

      > p {
        color: ${props => props.theme.colors.gray};
        font-size: 14px;
      }

      > svg {
        position: absolute;
        color: ${props => props.theme.colors.muted}80;
        right: 1px;
        top: 13px;
        right: 9px;
      }
    }
  }
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 1.5rem;
  background: ${props => props.theme.cards.primary};
  border: 1px solid ${props => props.theme.cards.border};
  border-radius: 0 0 ${props => props.theme.radius.primary} ${props => props.theme.radius.primary};
  width: 100%;

  > main {
    position: relative;

    > div {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .progress-graph {
        transform: rotate(190deg);
      }
    }
  }
`;

export const SpeedometerContainer = styled.div`
  overflow: hidden;
  position: relative;
`;

export const Speedbox = styled.div`
  height: 200px;
  width: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin-bottom: -100px;
  zoom: 1.5;
`;

export const Groove = styled.div`
  height: 100px;
  width: 200px;
  background: transparent;
  border-top-left-radius: 100px;
  border-top-right-radius: 100px;
  border: 20px solid ${props => props.theme.cards.tertiary};
  border-bottom: 0;
  box-sizing: border-box;
  position: absolute;
  left: 0;
  top: 0;
`;

interface ScoreProps {
  rotation: number;
}

export const Score = styled.div<ScoreProps>`
  position: absolute;
  left: 0;
  top: 0;
  height: 200px;
  width: 200px;
  background: transparent;
  border-radius: 50%;
  border: 20px solid ${props => props.theme.colors.muted};
  border-color: transparent transparent ${props => props.theme.colors.primary} ${props => props.theme.colors.primary};
  box-sizing: border-box;
  cursor: pointer;
  z-index: 1;
  transition: transform 0.3s ease;
  transform: rotate(${props => props.rotation}deg);
`;

export const Odometer = styled.div`
  text-align: center;
  position: absolute;
  color: ${props => props.theme.colors.muted};
  bottom: 100px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9;
  width: 100%;

  > h6 {
    font-size: 6px;
    color: ${props => props.theme.colors.muted};
    text-transform: uppercase;
    font-weight: 400;
    margin-bottom: 0.5rem;
  }

  > h1 {
    font-size: 2rem;
    color: ${props => props.theme.colors.white};
    margin-bottom: 0.25rem;
    font-weight: 800;

    > span {
      font-size: 1.5rem;
    }
  }
`;

export const Base = styled.div`
  width: 240px;
  height: 100px;
  background: ${props => props.theme.cards.primary};
  position: relative;
  top: 100px;
  z-index: 20;

  &:before {
    content: '';
    width: 240px;
    position: absolute;
    top: 0;
  }
`;

export const Footer = styled.footer`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  margin-top: 1rem;

  > div {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: row;
    width: 100%;
    display: grid;
    grid-template-columns: 3fr 1fr;
    padding: 1rem;
    border-bottom: 1px solid ${props => props.theme.cards.border};

    &:last-child {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
    }

    > aside {
      position: relative;
      display: flex;
      flex-direction: row;
      width: 100%;
      gap: 1rem;

      > aside {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        > div {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          background: ${props => props.theme.cards.tertiary};
          padding: 0.75rem;
          border-radius: 50%;

          > svg {
            color: ${props => props.theme.colors.primary};
          }
        }
      }

      > main {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;

        > h6 {
          font-size: 10px;
          color: ${props => props.theme.colors.muted};
          text-transform: uppercase;
          font-weight: 400;
        }

        > h3 {
          font-size: 0.95rem;
          color: ${props => props.theme.colors.white};
          font-weight: 600;
        }
      }
    }

    > footer {
      position: relative;
      display: flex;
      justify-content: flex-end;
      width: 100%;
      align-items: center;

      > h5 {
        font-size: 1.25rem;
        color: ${props => props.theme.colors.white};
        font-weight: 600;
      }
    }
  }
`;
